module.exports = __webpack_public_path__ + "img/algorithm.605fa3e5.svg";